import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import Excerpt from './components/Excerpt';
export default function addSummaryExcerpt() {
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (typeof params.include === 'string') {
      params.include = [params.include];
    } else {
      params.include = params.include || [];
    }
    if (app.forum.attribute('synopsis.excerpt_type') === 'first') {
      params.include.push('firstPost');
    } else {
      params.include.push('lastPost');
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    var _app$session$user$pre, _tag, _tag2, _tag3, _tag4, _app$session$user$pre2;
    const discussion = this.attrs.discussion;
    if (app.session.user && !((_app$session$user$pre = app.session.user.preferences()) != null && _app$session$user$pre.showSynopsisExcerpts)) {
      return;
    }
    const tags = discussion.tags();
    let tag;
    if (tags) {
      tag = tags[tags.length - 1];
    }
    const excerptPost = app.forum.attribute('synopsis.excerpt_type') === 'first' ? discussion.firstPost() : discussion.lastPost();
    const excerptLength = typeof ((_tag = tag) == null ? void 0 : _tag.excerptLength()) === 'number' ? (_tag2 = tag) == null ? void 0 : _tag2.excerptLength() : app.forum.attribute('synopsis.excerpt_length');
    const richExcerpt = typeof ((_tag3 = tag) == null ? void 0 : _tag3.richExcerpts()) === 'number' ? (_tag4 = tag) == null ? void 0 : _tag4.richExcerpts() : app.forum.attribute('synopsis.rich_excerpts');
    const onMobile = app.session.user ? (_app$session$user$pre2 = app.session.user.preferences()) == null ? void 0 : _app$session$user$pre2.showSynopsisExcerptsOnMobile : false;

    // A length of zero means we don't want a synopsis for this discussion, so do nothing.
    if (excerptLength === 0) {
      return;
    }
    if (excerptPost) {
      const excerpt = m(Excerpt, {
        post: excerptPost,
        length: excerptLength,
        richExcerpt: richExcerpt
      });
      items.add('excerpt', excerpt, -100);
      onMobile && items.add('excerptM', excerpt, -100);
    }
  });
}